import { CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import usePermission from "../hooks/usePermission";
import { pageKey } from "../utils/permissions";
import NoAccess from "../pages/NoAccess/NoAccess";

// Opens the page only when the role has the permission (a key, or a list = any of them); waits while the
// permissions load. The API refuses the requests too - this only keeps the user off an empty / refused page.
const RequirePermission = ({ perm, children }) => {
  const { loading, can } = usePermission();

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: 48 }}>
        <CircularProgress size={28} />
      </div>
    );
  }
  return can(perm) ? children : <NoAccess />;
};

export default RequirePermission;

// The create / edit form of a resource page: /<form path>/new needs "create", /<form path>/:id needs "edit"
export const RequireFormPermission = ({ slug, children }) => {
  const { id } = useParams();
  return <RequirePermission perm={pageKey(slug, id === "new" ? "create" : "edit")}>{children}</RequirePermission>;
};
